import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["containerRef", "pauseOnHover", "intersectionActivate"];
import { useCallback, useMemo, useState } from 'react';
import { useElementInView } from "../../../../hooks/useElementInView";
export var useIsAutoplayActive = function useIsAutoplayActive(_ref) {
  var containerRef = _ref.containerRef,
    pauseOnHover = _ref.pauseOnHover,
    _ref$intersectionActi = _ref.intersectionActivate,
    intersectionActivate = _ref$intersectionActi === void 0 ? false : _ref$intersectionActi,
    params = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMouseOverSwiper = _useState4[0],
    setIsMouseOverSwiper = _useState4[1];
  var isSwiperInView = useElementInView(containerRef, {
    intersectionActivate: intersectionActivate || 0,
    isActive: typeof intersectionActivate === 'number',
    deps: [intersectionActivate]
  });
  var mouseHandler = useCallback(function (type) {
    return function (e) {
      if (pauseOnHover) {
        setIsMouseOverSwiper(type === 'enter');
      }
      var eventHandler = type === 'leave' ? params.onMouseLeave : params.onMouseEnter;
      eventHandler === null || eventHandler === void 0 ? void 0 : eventHandler(e);
    };
  }, [pauseOnHover]);
  return useMemo(function () {
    var isPlay = isActive && !isMouseOverSwiper && (typeof intersectionActivate === 'number' ? isSwiperInView : true);
    return {
      isPlay: isPlay,
      progressBarHidden: !isActive,
      setIsActive: setIsActive,
      options: {
        onMouseEnter: mouseHandler('enter'),
        onMouseLeave: mouseHandler('leave')
      }
    };
  }, [isSwiperInView, isMouseOverSwiper, isActive, pauseOnHover, intersectionActivate]);
};